import React from "react";
import "./index.css";

export default function Footer() {
  return (
    <footer className="pt-2">
      <a
        href="https://github.com/soybella/react-weather-app-project"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>{" "}
      <span> made with ♥︎ by Isabella Lizarde</span>
    </footer>
  );
}
